import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { InlineWidget } from "react-calendly";

const CALENDLY_URL =
  "https://calendly.com/sachinpadhiyar/business-alliance?month=2024-05&a2=";

const Modal = ({ isOpen, onClose }) => {
  const router = useRouter();
  const pathname = router.asPath.split("/")[1];

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  return (
    isOpen && (
      <div className="fixed top-0 w-full h-screen bg-black/60 z-50">
        <div className="absolute left-2 md:left-auto md:right-10 top-5 lg:top-10 md:top-5 xl:top-10">
          <button onClick={onClose}>
            <FontAwesomeIcon
              icon={faXmark}
              className="text-black md:text-white text-3xl"
              width={40}
              height={40}
            />
          </button>
        </div>
        <div className="flex justify-center items-center h-screen">
          <InlineWidget
            url={`${CALENDLY_URL}${pathname}`}
            styles={{
              height: `${window.innerWidth >= 1440 ? "75vh" : "100vh"}`,
              width: "100%",
            }}
          />
        </div>
      </div>
    )
  );
};

export default Modal;
